import React from 'react';
import { Download } from 'lucide-react';
import { useInstallPrompt } from '../hooks/useInstallPrompt';

export const InstallButton: React.FC = () => {
    const { isInstallable, promptInstall } = useInstallPrompt();

    if (!isInstallable) return null;

    return (
        <button
            onClick={promptInstall}
            className="fixed bottom-4 right-4 z-50 flex items-center gap-2 px-4 py-3 bg-accent text-white rounded-lg shadow-lg hover:bg-accent/90 transition-all duration-200 animate-bounce"
            style={{ animationIterationCount: 3 }}
        >
            <Download size={20} />
            <span className="font-medium">Installer l'application</span>
        </button>
    );
};
